import type { FlavourFeatures } from '@/flavours';

export type GrmsIndicatorFeatures = Pick<FlavourFeatures, 'hasDND' | 'hasMUR'>;

interface GrmsIndicatorSource {
  dndActive?: boolean | null;
  murActive?: boolean | null;
}

export interface GrmsIndicators {
  dnd: boolean;
  mur: boolean;
}

/** Resolve live-over-REST GRMS indicators and apply the active flavour gates. */
export function resolveGrmsIndicators(
  room: GrmsIndicatorSource,
  liveState: GrmsIndicatorSource | null | undefined,
  features: GrmsIndicatorFeatures,
): GrmsIndicators {
  return {
    dnd: features.hasDND && (liveState?.dndActive ?? room.dndActive ?? false),
    mur: features.hasMUR && (liveState?.murActive ?? room.murActive ?? false),
  };
}
